<template>
  <div id="content">
    <loader v-if="loading"></loader>
    <div id="list" v-else>
      <div v-if="payments.length > 0">
        <b-table small striped hover :items="payments">
          <template
            v-slot:cell(created_at)="payment"
          >{{ payment.value | moment("DD/MM/YYYY HH:mm") }}</template>
        </b-table>
        <div class="ml-auto">
          <b-pagination @change="setPage" :disabled="loading" align="right" v-model="page"></b-pagination>
        </div>
      </div>

      <div class="card text-center" v-else>
        <div class="card-body">
          <h5 class="card-title">Search Result</h5>
          <p class="card-text">No Data</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentLoader from "../../../../components/ContentLoader";
import GetDriverMembershipPayments from "../../../../store/actions/getDriverMembershipPayments";
import ShowError from "../../../../helpers/showError";

export default {
  name: "DriverMembershipPayments",
  components: {
    loader: ContentLoader
  },
  created() {
    this.getPayments();
  },
  data() {
    return {
      payments: [],
      loading: true,
      page: 1
    };
  },
  methods: {
    setPage(page) {
      this.search.page = page;
      this.getPayments();
    },
    async getPayments() {
      try {
        this.loading = true;
        this.payments = await GetDriverMembershipPayments(
          this.$route.params.id,
          this.page
        );
      } catch (e) {
        ShowError(this, e);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
